import type { Filters } from '@/domain';
import { Filter } from '../filters/Filter';
import { SmallFhhMap } from '../smallFhhMap/SmallFhhMap';

type ResultFilterProps = {
    filters: Filters;
    filterData: Record<string, unknown>;
    onFilterChanged: (filters: Filters) => void;
};

export const ResultFilter = (props: ResultFilterProps) => (
    <>
        <SmallFhhMap filters={props.filters} />
        <Filter onFilterChanged={props.onFilterChanged} filterData={props.filterData} filters={props.filters} />
    </>
);
